import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { TotemService } from '../totem.service';
import { Categoria } from './categoria';
import { Tienda } from './tienda';
import { EventEmitterService } from '../event-emitter.service';

@Component({
  selector: 'app-tiendas',
  templateUrl: './tiendas.component.html',
  styleUrls: ['./tiendas.component.css']
})
export class TiendasComponent implements OnInit, OnDestroy {
  mostrarMenu = false;
  mostrarCat = false;
  tiendas = [];
  tiendasSinfiltro = [];
  tiendasPorCategoria = [];
  subcategorias = [];
  tiendasCargadas = false;
  Mostrar = true;
  textoMostrar = 'Mostrar';

  listaFiltros = ['A B', 'C D', 'E F', 'G H', 'I J', 'K L',
                  'M N', 'O P', 'Q R', 'S T', 'U V', 'W X', 'Y Z', '0 - 9'];

  filtrosLetras = [];
  filtroCategoria = '';

  tipoRuta = '';

  subscription;
  public actual: string = '';

  constructor(private totemService: TotemService, private route: ActivatedRoute,
              private router: Router, private eventEmitterService: EventEmitterService) {
              router.events.subscribe((val) => {
                this.cambioRuta();
              });
              this.subscription = this.totemService.getLanguage().subscribe(language => {
                this.actual = language;
                this.obtenerTiendas();
                this.actalizarFiltro();
              });
   }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
  firstComponentFunction() {
    this.eventEmitterService.activarFooter('funcioncita');
  }

  async cambioRuta() {
    await this.obtenerTiendas();
    this.tipoRuta = this.route.snapshot.paramMap.get('tipo');
    switch ( this.tipoRuta ) {
      case 'restaurante':
        this.filtroCategoria = 'Restaurante';
        this.agregarFiltros('categoria', this.filtroCategoria );
        break;
      case 'tiendas':
        this.filtroCategoria = '';
        this.tiendas = this.tiendasSinfiltro.slice();
        break;
    }
  }
  cambioMostrar() {
    this.Mostrar = !this.Mostrar;
    this.textoMostrar = this.Mostrar ? 'Mostrar': 'Ocultar';
  }

  async obtenerTiendas() {
    try {
      // obtener tiendas
      const resultado = await this.totemService.obtenerTiendasOrdenadas(this.actual);
      // obtener categorias
      this.subcategorias = await this.totemService.obtenerCategoriasPorTiendas(this.actual,resultado);
      this.tiendas = this.totemService.sortByKey(resultado);
      this.tiendasSinfiltro = this.tiendas.slice();
      this.tiendasCargadas = true;
      console.log('[TIENDAS]', this.tiendas);
      console.log('[CATEGORIAS]', this.subcategorias);
    } catch (err) {
      console.error(err);
    }
  }

  agregarFiltros(tipoFiltro: string, filtro?: any, ) {
    console.log("el filtro",filtro );
    const otherFilter = filtro === 'MOSTRAR TODO' ? this.getTranslation('mostrarTodo') : filtro;
    switch (tipoFiltro) {
      case 'categoria':
        this.filtroCategoria = filtro;
        this.filtroPorCategoria(this.filtroCategoria);
        console.log('[FILTRO CATEGORIA]', this.filtroCategoria);
        break;
      case 'letras':
        if (filtro === 'MOSTRAR TODO') {
          this.filtrosLetras = [otherFilter];
          this.tiendas = this.filtroCategoria === '' ?
          this.tiendas = this.tiendasSinfiltro.slice() : this.tiendas = this.tiendasPorCategoria.slice();
        } else {
          if (this.filtrosLetras.indexOf('MOSTRAR TODO') !== -1) {
            this.filtrosLetras.splice(this.filtrosLetras.indexOf('MOSTRAR TODO'), 1);
          }
          if (this.filtrosLetras.indexOf(filtro) === -1) {
            this.filtrosLetras.push(otherFilter); 
          }
          this.filtroPorLetras(this.filtrosLetras);
        }
        console.log('[FILTRO LETRAS]', this.filtrosLetras);
        break;
    }
  }

  actalizarFiltro(){
    if (this.filtrosLetras.indexOf('MOSTRAR TODO') !== -1) {
      const otherFilter = this.getTranslation('mostrarTodo');
      this.filtrosLetras = [otherFilter];
    }
  }

  eliminarFiltros(filtro: any, tipoFiltro: string) {
    switch (tipoFiltro) {
      case 'categoria':
        this.filtroCategoria = '';
        this.filtroPorCategoria(this.filtroCategoria);
        // console.log('[FILTRO CATEGORIA]', this.filtroCategoria);
        break;
      case 'letras':
        if (this.filtrosLetras.indexOf(filtro) !== -1) {
          this.filtrosLetras.splice(this.filtrosLetras.indexOf(filtro), 1);
        }
        this.filtrosLetras.length > 0 ? this.filtroPorLetras(this.filtrosLetras) : this.filtroCategoria === '' ?
        this.tiendas = this.tiendasSinfiltro.slice() : this.tiendas = this.tiendasPorCategoria.slice();
        // console.log('[FILTRO LETRAS]', this.filtrosLetras);
        break;
    }
  }

  filtroPorCategoria(categoriaSelect: string) {
    if (categoriaSelect === '') {
      this.filtroporletra();
    } else {
      const listaTiendas = this.subcategorias.filter(categorias => {
        return categorias.nombre === categoriaSelect;
      });
      this.tiendasPorCategoria = this.totemService.sortByKey(listaTiendas[0].tiendas);
      this.filtroporletra();
    }
  }

  filtroPorLetras(listaLetras: any) {
    const letrasFiltro = this.formatoLetras(listaLetras);
    const listaDeTiendas = [];
    const tiendasPorFiltrar = this.filtroCategoria === '' ? this.tiendasSinfiltro.slice() : this.tiendasPorCategoria.slice();
    for (let i = 0; i < letrasFiltro.length; i++) {
      tiendasPorFiltrar.filter(tienda => {
        if (tienda.nombre[0] === letrasFiltro[i] && listaDeTiendas.indexOf(tienda) === -1) {
          listaDeTiendas.push(tienda);
        }
      });
    }
    this.tiendas = this.totemService.sortByKey(listaDeTiendas);
  }

  filtroporletra() {
    this.filtrosLetras.length > 0 ? this.filtroPorLetras(this.filtrosLetras) : this.filtroCategoria === '' ?
    this.tiendas = this.tiendasSinfiltro.slice() : this.tiendas = this.tiendasPorCategoria.slice();
  }

  formatoLetras(listaLetras: any) {
    const listaResult = [];
    for (let i = 0; i < listaLetras.length; i++ ) {
      listaResult.push(listaLetras[i].split(' ')[0]);
      listaResult.push(listaLetras[i].split(' ')[1]);
    }
    return listaResult;
  }

  mostrarFiltros() {
    this.mostrarMenu = !this.mostrarMenu;
    console.log(this.mostrarMenu);
  }
  mostrarCategorias() {
    this.mostrarCat = !this.mostrarCat;
    console.log(this.mostrarCat);
  }

  eliminarFiltrados(tiendasporfiltrar: any, tiendasfiltradas: any) {
    const nuevalista = tiendasporfiltrar.filter( tienda => {
      return tiendasfiltradas.indexOf(tienda) === -1;
    });
    return nuevalista;
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }
}
